import PropTypes from 'prop-types'

function CodeView({ json }) {
  if (!json) return false

  return (
    <div className="mx-auto h-96 w-full overflow-y-auto rounded-lg shadow-lg">
      <div className="prose max-w-none">
        <pre>{JSON.stringify(json, undefined, 2)}</pre>
      </div>
    </div>
  )
}

CodeView.propTypes = {
  json: PropTypes.object,
}

export default CodeView
